export default __webpack_public_path__ + "static/media/profile-pic-cropped.455ea382.jpg";